import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const programs = [
    {
      title: 'Despertar',
      description: 'Autoconhecimento e desenvolvimento de liderança pessoal',
      icon: 'ri-lightbulb-line',
      link: '/programas#despertar'
    },
    {
      title: 'Capacita',
      description: 'Cursos profissionalizantes e capacitações técnicas',
      icon: 'ri-graduation-cap-line',
      link: '/programas#capacita'
    },
    {
      title: 'Geração Valor',
      description: 'Programa de juventude e liderança transformadora',
      icon: 'ri-team-line',
      link: '/programas#geracao-valor'
    },
    {
      title: 'Mentorias',
      description: 'Acompanhamento individual e trilhas personalizadas',
      icon: 'ri-user-star-line',
      link: '/programas#mentorias'
    },
    {
      title: 'Trilhas EAD',
      description: 'Plataforma online com cursos e certificações',
      icon: 'ri-computer-line',
      link: '/programas#ead'
    },
    {
      title: 'Encaminhamento',
      description: 'Conexão direta com o mercado de trabalho',
      icon: 'ri-briefcase-line',
      link: '/mercado-trabalho'
    }
  ];

  const testimonials = [
    {
      name: 'Ana Carolina Silva',
      role: 'Formada em Gestão de Pessoas',
      text: 'O Instituto Allcance transformou minha vida. Descobri meu propósito e hoje trabalho na área que sempre sonhei.',
      image: 'https://public.readdy.ai/ai/img_res/007f5a503ed5658a2d9c05d3e8e8d93b.jpg'
    },
    {
      name: 'Rafael Mendes',
      role: 'Técnico em TI',
      text: 'Fiz o curso de capacitação e em 3 meses já estava empregado. A equipe me preparou para o mercado de verdade.',
      image: 'https://readdy.ai/api/search-image?query=young%20professional%20brazilian%20man%20smiling%20confident%20casual%20tech%20worker%20modern%20workspace%20natural%20lighting%20warm%20tones%20professional%20headshot%20style%20clean%20simple%20background%20authentic%20genuine%20expression%20success%20achievement&width=400&height=400&seq=testimonial2&orientation=squarish'
    },
    {
      name: 'Juliana Costa',
      role: 'Líder Comunitária',
      text: 'O programa Geração Valor me ensinou a liderar com propósito. Hoje impacto minha comunidade positivamente.',
      image: 'https://readdy.ai/api/search-image?query=young%20professional%20brazilian%20woman%20leader%20smiling%20confident%20community%20worker%20natural%20lighting%20warm%20tones%20professional%20headshot%20style%20clean%20simple%20background%20authentic%20genuine%20expression%20leadership%20empowerment&width=400&height=400&seq=testimonial3&orientation=squarish'
    }
  ];

  const pillars = [
    {
      icon: 'ri-mind-map',
      title: 'Autoconhecimento',
      description: 'Descubra seu propósito, valores e potencial único através de metodologias comprovadas'
    },
    {
      icon: 'ri-tools-line',
      title: 'Capacitação Profissional',
      description: 'Cursos técnicos, EAD e treinamentos que preparam você para o mercado de trabalho'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Encaminhamento ao Mercado',
      description: 'Conexão direta com empresas parceiras e oportunidades reais de emprego'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(15, 23, 42, 0.95) 0%, rgba(15, 23, 42, 0.85) 40%, rgba(15, 23, 42, 0.3) 100%), url('https://readdy.ai/api/search-image?query=diverse%20group%20young%20adults%20students%20studying%20together%20modern%20bright%20classroom%20collaborative%20learning%20environment%20natural%20sunlight%20warm%20atmosphere%20books%20laptops%20engaged%20focused%20multicultural%20team%20educational%20setting%20professional%20photography%20inspiring%20hopeful%20mood%20clean%20organized%20space&width=1920&height=1080&seq=hero1&orientation=landscape')`
        }}
      >
        <div className="container mx-auto px-6 py-20">
          <div className="max-w-2xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Desenvolvimento pessoal, profissional e propósito para transformar vidas
            </h1>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Descubra seu potencial, capacite-se profissionalmente e alcance o futuro que você sempre quis.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/inscricoes" 
                className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-slate-900 px-8 py-4 rounded-full font-semibold text-lg hover:from-yellow-500 hover:to-yellow-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Quero ser aluno
              </Link>
              <Link 
                to="/sobre" 
                className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
              >
                Conheça o Instituto
              </Link>
            </div>
            <div className="mt-12 flex items-center gap-3">
              <div className="h-1 w-16 bg-gradient-to-r from-yellow-400 to-purple-500"></div>
              <p className="text-2xl font-bold text-yellow-400" style={{ fontFamily: "'Pacifico', serif" }}>
                Allcance o futuro que quiser!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Pillars Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Nossos 3 Pilares de Atuação</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Uma jornada completa de transformação pessoal e profissional
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {pillars.map((pillar, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-slate-100">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${pillar.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4">{pillar.title}</h3>
                <p className="text-slate-600 leading-relaxed">{pillar.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-slate-900 mb-6">Quem Somos</h2>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                O <strong>Instituto Allcance</strong> nasceu com o propósito de transformar vidas através do desenvolvimento humano integral. Acreditamos que cada pessoa tem um potencial único e nosso papel é ajudar a descobrir, desenvolver e direcionar esse potencial para o mercado de trabalho.
              </p>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                Nossa missão é promover o autoconhecimento, capacitação profissional e encaminhamento ao mercado, criando pontes entre sonhos e realizações concretas.
              </p>
              <p className="text-lg text-slate-700 mb-8 leading-relaxed">
                Trabalhamos com <strong>transparência, vontade, inconformismo, referência, influência e transformação</strong> como valores inegociáveis.
              </p>
              <Link 
                to="/sobre" 
                className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Conheça nossa história
              </Link>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20team%20meeting%20diverse%20group%20mentors%20instructors%20modern%20bright%20office%20collaborative%20workspace%20natural%20lighting%20warm%20welcoming%20atmosphere%20educational%20institute%20staff%20engaged%20discussion%20professional%20photography%20authentic%20genuine%20interaction%20inspiring%20environment&width=800&height=600&seq=about1&orientation=landscape"
                alt="Equipe Instituto Allcance"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
              <div className="absolute -bottom-6 -left-6 bg-gradient-to-br from-yellow-400 to-yellow-500 p-6 rounded-2xl shadow-xl">
                <p className="text-4xl font-bold text-slate-900">+5000</p>
                <p className="text-slate-800 font-semibold">Vidas transformadas</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Nossos Programas</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Escolha o caminho ideal para sua transformação pessoal e profissional
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {programs.map((program, index) => (
              <Link 
                key={index}
                to={program.link}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all border border-slate-100 group cursor-pointer"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <i className={`${program.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-4 group-hover:text-blue-600 transition-colors">
                  {program.title}
                </h3>
                <p className="text-slate-600 leading-relaxed mb-4">{program.description}</p>
                <div className="flex items-center text-blue-600 font-semibold group-hover:gap-3 transition-all">
                  <span>Saiba mais</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">Histórias de Transformação</h2>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Conheça quem já alcançou seus objetivos com o Instituto Allcance
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100">
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h4 className="font-bold text-slate-900">{testimonial.name}</h4>
                    <p className="text-sm text-slate-600">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-slate-700 leading-relaxed italic">"{testimonial.text}"</p>
                <div className="flex gap-1 mt-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto para transformar sua vida?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Junte-se a milhares de pessoas que já descobriram seu propósito e alcançaram seus objetivos profissionais.
          </p>
          <Link 
            to="/inscricoes" 
            className="inline-block bg-yellow-400 text-slate-900 px-10 py-5 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-2xl hover:shadow-yellow-400/50 whitespace-nowrap cursor-pointer"
          >
            Quero ser aluno agora
          </Link>
        </div>
      </section>

      <Footer />

      {/* Floating CTA Button */}
      <Link 
        to="/inscricoes"
        className="fixed bottom-8 right-8 bg-gradient-to-r from-yellow-400 to-yellow-500 text-slate-900 px-6 py-4 rounded-full font-bold shadow-2xl hover:shadow-yellow-400/50 transition-all z-50 flex items-center gap-2 whitespace-nowrap cursor-pointer hover:scale-105"
      >
        <i className="ri-user-add-line text-xl"></i>
        <span>Quero ser aluno</span>
      </Link>
    </div>
  );
}
